"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const react_1 = require("react");
const SvgShuttle = (props, ref) => (React.createElement("svg", { ...props, xmlns: "http://www.w3.org/2000/svg", xmlSpace: "preserve", viewBox: "0 0 1024 1024", fill: "currentColor", className: `Icon ${props?.className || ""}`, ref: ref },
    React.createElement("path", { d: "M956 220.5h-43v-15.4c0-83.8-67.9-152-151.2-152H262.2c-83.4 0-151.2 68.2-151.2 152v15.4H54.1C24.3 220.5 0 244.9 0 274.9v139.5c0 30 24.3 54.3 54.1 54.3H111v390.5h55.5v43.3c0 37.7 30.5 68.3 68 68.3h111c37.5 0 68-30.6 68-68.3v-43.3h197v43.3c0 37.7 30.5 68.3 68 68.3h111c37.5 0 68-30.6 68-68.3v-43.3H913l-.2-347.2v-43.3H956c37.5 0 68-30.6 68-68.3V288.8c0-37.6-30.5-68.3-68-68.3m-10.7 76.2v95h-27.7v-95zm-114.1-95.2V219H198.7v-17.5c0-42.7 31.3-77.5 69.7-77.5h493.2c38.3 0 69.6 34.8 69.6 77.5M546.9 492.2V298.7h278.4v193.5zm284.3 94.2V780H198.7V586.4zm-632.5-94.2V298.7h278.4v193.5zm-92.4-195.5v95H78.7v-95zm186.2 310.6c40.9 0 74 32.5 74 72.5s-33.1 72.5-74 72.5-74-32.5-74-72.5 33.1-72.5 74-72.5m439 0c40.9 0 74 32.5 74 72.5s-33.1 72.5-74 72.5-74-32.5-74-72.5 33.1-72.5 74-72.5" })));
const ForwardRef = (0, react_1.forwardRef)(SvgShuttle);
exports.default = ForwardRef;
